import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPageAR } from './pages/LandingPageAR';
import { LandingPageUS } from './pages/LandingPageUS';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Defer Meta Pixel to after initial render
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => initMetaPixel());
    } else {
      setTimeout(() => initMetaPixel(), 2000);
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <main className="min-h-screen bg-background font-sans text-navy selection:bg-accent selection:text-white" data-id="element-1">
        {/* noscript fallback for Meta Pixel */}
        <noscript data-id="element-2">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=793935510144655&ev=PageView&noscript=1" alt="" data-id="element-3" />
        </noscript>

        <Routes data-id="element-4">
          <Route path="/" element={<LandingPageAR data-id="element-6" />} data-id="element-5" />
          <Route path="/ar" element={<LandingPageAR data-id="element-8" />} data-id="element-7" />
          <Route path="/us" element={<LandingPageUS data-id="element-10" />} data-id="element-9" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-12" />} data-id="element-11" />
        </Routes>
      </main>
    </BrowserRouter>;
}